import {
  useState
} from "react";
import {
  Link
} from "react-router-dom";

import StaffForm from "../components/StaffForm";

import {
  createStaff
} from "../api/staffApi";                  // owner API
import {
  createStaffForPortal
} from "../api/staffPortalApi";   // portal API

import {
  Card,
  CardContent,
  Badge
} from "../components/ui";
import {
  useToast
} from "../context/ToastContext";

const AddStaff = ({ isPortal = false }) => {
  const [loading, setLoading] = useState(false);
  const [credentials, setCredentials] = useState(null);

  const toast = useToast();

  const homeUrl = isPortal ? "/staff-home" : "/school-home";
  const staffListUrl = isPortal ? "/staff-panel/staff" : "/staff";

  const handleSubmit = async (formData) => {
    try {
      setLoading(true);

      const data = isPortal
        ? await createStaffForPortal(formData)
        : await createStaff(formData);

      setCredentials(data.credentials);
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "Failed to create staff"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-4xl mx-auto space-y-6 bg-neutral-50 dark:bg-neutral-950 min-h-screen">
      {/* Top Breadcrumb Header (Borderless) */}
      <div className="pb-2 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div>
          <nav className="mb-1 flex items-center gap-2 text-xs font-extrabold text-neutral-400 dark:text-neutral-500">
            <Link to={homeUrl} className="hover:text-indigo-600 transition-colors">
              Home
            </Link>
            <span>/</span>
            <Link to={staffListUrl} className="hover:text-indigo-600 transition-colors">
              Staff Management
            </Link>
            <span>/</span>
            <span className="text-neutral-800 dark:text-neutral-100">Add Staff</span>
          </nav>
          <h1 className="text-xl sm:text-2xl font-bold text-neutral-900 dark:text-neutral-100 tracking-tight">
            Add Staff Member
          </h1>
        </div>

        {isPortal && (
          <Badge variant="secondary" className="w-fit text-[10px] font-extrabold bg-slate-100 dark:bg-neutral-900 text-neutral-700 dark:text-neutral-200 uppercase">
            Staff Portal Mode
          </Badge>
        )}
      </div>

      {/* Error Feedback */}
      

      {/* Generated Credentials Output (Tabular Form, Borderless) */}
      {credentials && (
        <Card className="bg-emerald-50/50 rounded-2xl">
          <CardContent className="p-5 space-y-4">
            <h3 className="text-xs font-extrabold text-emerald-800 uppercase tracking-wider">
              Staff Account Created Successfully
            </h3>

            <div className="overflow-x-auto rounded-xl bg-white dark:bg-neutral-900">
              <table className="w-full text-left text-xs border-collapse">
                <tbody>
                  <tr className="bg-white dark:bg-neutral-900">
                    <td className="w-1/3 py-3 px-4 font-bold text-neutral-400 dark:text-neutral-500">
                      Staff Code
                    </td>
                    <td className="py-3 px-4 font-mono font-bold text-neutral-800 dark:text-neutral-100">
                      {credentials.staffCode}
                    </td>
                  </tr>
                  <tr className="bg-neutral-50/50 dark:bg-neutral-950">
                    <td className="w-1/3 py-3 px-4 font-bold text-neutral-400 dark:text-neutral-500">
                      Initial Password
                    </td>
                    <td className="py-3 px-4 font-mono font-bold text-neutral-800 dark:text-neutral-100">
                      {credentials.password}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p className="text-[11px] font-semibold text-neutral-500 dark:text-neutral-400">
              Please securely share these credentials with the staff member. The password will not be displayed again.
            </p>
          </CardContent>
        </Card>
      )}

      {/* Main Form Container */}
      <div className="pt-2">
        <StaffForm
          onSubmit={handleSubmit}
          loading={loading}
          isPortal={isPortal}
        />
      </div>
    </div>
  );
};

export default AddStaff;